import {afterDomIsReady} from '../utils/whenLoaded';
import {initializeCalculatorStorage, initializePatientStorage} from '../stateHandler';
import {getRangeInputByName, getRangeTickmarksByInputName} from '../utils/formFields';
import {assert} from '../utils/assert';
import {loadTemplate} from '../utils/loadTemplate';
import {updateTickmarks} from '../utils/updateTickmarks';

export default () => afterDomIsReady(async () => {
	const templateEl = document.getElementById('napsi-template') as HTMLTextAreaElement;
	assert(templateEl !== null);
	const getTemplate = await loadTemplate('./napsi-template.html');

	const storage = initializeCalculatorStorage();
	const currentState: { [key: string]: string | number } = {};

	const recountRow = function (prefix: string) {
		const matrix = getRangeInputByName(`${prefix}0`).value;
		updateTickmarks(getRangeTickmarksByInputName(`${prefix}0`), matrix);

		const bed = getRangeInputByName(`${prefix}1`).value;
		updateTickmarks(getRangeTickmarksByInputName(`${prefix}1`), bed);

		const sum = parseFloat(matrix) + parseFloat(bed);
		document.getElementById(`napsi-form-${prefix}a`)!.innerText = sum.toFixed(0);
		currentState[prefix + '0'] = matrix;
		currentState[prefix + '1'] = bed;
		currentState[prefix + 'a'] = sum;
		return sum;
	};

	const recount = () => {
		let total = 0;
		for (let i = 0; i <= 3; i++) {
			for (let j = 0; j <= 4; j++) {
				total += recountRow('r' + i + j);
			}
		}

		document.getElementById('napsi-score')!.innerText = total.toFixed(0);
		currentState['celkem'] = total;
		storage.update('napsi', currentState);
	};

	// now
	recount();

	// and on every field change
	document.querySelectorAll('input[type=range]').forEach(
		el => el.addEventListener('input', () => recount()));
	// IE fix:
	document.querySelectorAll('input[type=range]').forEach(
		el => el.addEventListener('change', () => recount()));


	const resultEl = document.getElementById('napsi-downloadForm');
	assert(resultEl !== null);
	resultEl.addEventListener('submit', () => {
		let template = getTemplate();

		const pacient = initializePatientStorage().get();
		template = template.replace('{titul}', pacient.degree || '');
		template = template.replace('{jmeno}', pacient.firstName || '');
		template = template.replace('{prijmeni}', pacient.lastName || '');
		template = template.replace('{datumVysetreni}', pacient.examinationDate || '');

		const state = storage.get('napsi');
		for (let i = 0; i <= 3; i++) {
			for (let j = 0; j <= 4; j++) {
				template = template.replace(`{r${i}${j}0}`, state[`r${i}${j}0`]);
				template = template.replace(`{r${i}${j}1}`, state[`r${i}${j}1`]);
				template = template.replace(`{r${i}${j}a}`, state[`r${i}${j}a`]);
			}
		}
		template = template.replace('{celkem}', state.celkem);

		templateEl.value = template;
	});
})
